import logger from '../../../utils/logger';
import type { IBatchStore } from '../batch-store-types';
import { handleJogModeDecumComplete } from './handle-jog-mode-decum-complete';
import { checkDecumHoldConditions } from './check-decum-hold-conditions';
import { timerKey } from '../../../utils/timer-manager/timer-manager';
import type { IWeighedDataToBatch } from '../../../../types/batch/DataToBatch';
import type { IBatchData } from '../../../containers/Batch/IBatchData';

/**
 * Handle when decum scale weight target is reached during discharge
 */
export const handleDecumWeightTargetReached = (
  batchStore: IBatchStore,
  data: IWeighedDataToBatch,
  initialData: IBatchData,
  scaleRef: any,
  scalePorts: { openPort: any; closePort: any; openPortAdditional: any; closePortAdditional: any },
) => {
  const { scale } = data;
  const { openPort, closePort, openPortAdditional, closePortAdditional } = scalePorts;

  if (batchStore.isActiveDrop(initialData)) {
    logger.log('scale weight status on finish', scale.id, 'close the scale gate & reset-weight');
    batchStore.closeScale(scale, openPort, closePort);
    if (batchStore.isDoubleGateScale(scale)) {
      batchStore.timers.clear(timerKey.secondGateOpen(scale.id));
      batchStore.closeScale(scale, openPortAdditional, closePortAdditional);
    }
    batchStore.resetWeight(scale.inputPNo);

    if (checkDecumHoldConditions(batchStore, initialData, scale, scaleRef)) {
      return;
    }

    batchStore.jogModeDecum(data, initialData, scaleRef, () => {
      handleJogModeDecumComplete(batchStore, data, initialData);
    });
  }
};
